<template>
  <div class="page404 u-containar">
    <h1 class="page404_img">
      <img src="@/assets/images/common/404.svg" alt="404 Not Found" />
    </h1>
    <p class="page404_lead">
      お探しのページは<br class="hiddenPc" />見つかりませんでした。
    </p>
    <div class="page404_btn">
      <Button
        label="トップページへ戻る"
        primary
        :handleClick="
          () => {
            $router.push('/')
          }
        "
      />
    </div>
  </div>
</template>

<script lang="ts">
import Button from '@/components/elements/Button.vue'

export default {
  name: 'NotFound',

  components: {
    Button
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.page404 {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 60px;
  padding-bottom: 60px;

  @include mixins.media(lg) {
    padding-top: 120px;
    padding-bottom: 120px;
  }

  &_img {
    width: 300px;
  }

  &_lead {
    text-align: center;
    font-size: 1.8rem;
    font-weight: 500;
    margin-top: 16px;
    line-height: 1.5;
  }

  &_btn {
    margin-top: 40px;
    width: 215px;
  }
}
</style>
